export const PARKING_ROUTES = {
  PARKING: '/my-home/parking',
  PARKING_LISTING: '/my-home/parking/listing',

  PARKING_SPACE_CONTRACT_INFO_PAGE: '/my-home/parking/contract/:contractId',

  SWITCH_PARKING_SPACES_LISTING: '/my-home/parking/switch-spaces',
  SWITCH_PARKING_SPACES_FORM: '/my-home/parking/switch-spaces/form',
  SWITCH_PARKING_SPACES_SUMMARY: '/my-home/parking/switch-spaces/summary',
  SWITCH_PARKING_SPACES_IDENTIFICATION_METHOD_PAGE:
    '/authentication/switch-to-another-parking-space',
  SWITCH_PARKING_SPACES_IDENTIFICATION_CALLBACK_PAGE:
    '/my-home/parking/switch-spaces/identification-callback',

  PARKING_SPACE_RENTING_FORM: '/my-home/parking/rent',
  PARKING_SPACE_RENTING_SUMMARY: '/my-home/parking/rent/summary',
  PARKING_TERMINATION: '/my-home/parking/termination',
  PARKING_SPACE_RENTING_IDENTIFICATION_METHOD_PAGE:
    '/authentication/renting-a-parking-space',
  PARKING_SPACE_RENTING_IDENTIFICATION_CALLBACK_PAGE:
    '/my-home/parking/rent/identification-callback',
} as const;

/** How far ahead in the contract start date can be set, in days. */
export const PARKING_RENTING_RANGE_DAYS = 45 as const;
